export const SET_ACTIVEHOMEWORK = 'SET_ACTIVEHOMEWORK'

export const SET_CLASSLIST = 'SET_CLASSLIST'

export const SET_HISTORYWORKLIST = 'SET_HISTORYWORKLIST'

export const SET_STUHOMEWORK = 'SET_STUHOMEWORK'

export const SET_PEERWORKLIST = 'SET_PEERWORKLIST'

export const SET_PEERTASK = 'SET_PEERTASK'

export const SET_MARK = 'SET_MARK'

export const SET_ATTACH = 'SET_ATTACH'

export const UPDATELOADINGSTATUS = 'UPDATELOADINGSTATUS'

export const SET_COURSEROLE = 'SET_COURSEROLE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js